import { EventBus, type EventsMap } from '@databases/event-bus';

/**
 * Defines the mapping between event names and their associated payload structures.
 * Each key represents an event name used during dispatch, and the value specifies
 * the payload shape received by the event listener.
 */
export interface CoreEventBusEvents extends EventsMap {
  /**
   * Fired when bridge identity fields for collab / load change (contentId, Canvas reference, space).
   * Emitted from the bridge Valtio subscription when the identity slice differs from the last
   * emitted snapshot (registration seeds internal state without emit).
   */
  bridgeDatabaseIdentityChanged: {
    contentId: string;
    contentReferenceId: string;
    spaceId: string;
    spaceKey: string;
  };

  /**
   * This only happens from dev tools and can eventually be deprecated. This event fires when the local dev UI changes
   * feature flag state but our feature flag state is primarily non-reactive. So, a page refresh is usually required.
   */
  featureFlagsChanged: Record<string, boolean>;
  /** Fired when we want to show the action bar due to database selections. */
  showActionBar: null;
  /** Fired when we want to hide the action bar. */
  hideActionBar: null;
  /** Fired when Databases shows a context menu and wants Whiteboards to dismiss theirs. */
  databaseContextMenuShown: null;
  /** Fired when databases decides not to handle a copy clipboard event (empty payload case). */
  forwardCopyClipboardToParent: null;
  /** Fired when databases decides not to handle a cut clipboard event (empty payload case). */
  forwardCutClipboardToParent: null;
}

export class CoreEventBus extends EventBus<CoreEventBusEvents> {}
